module.exports = __webpack_public_path__ + "img/kruisje-wit.687fab741c7d92efe359b9ada58a7e8c.svg";